import { Box } from '@machobear/design-system'
import BaseLayout from '@/features/Settings/Layout/base-layout'
import useRole from '@/hooks/use-role'
import LandlordPaymentSettings from './landlord'
import TenantPaymentSettings from './tenant'

const PaymentSettings = () => {
  const role = useRole()

  return (
    <BaseLayout>
      <Box background="bodyWhite" width="full">
        {role === 'tenant' ? <TenantPaymentSettings /> : <LandlordPaymentSettings />}
      </Box>
    </BaseLayout>
  )
}

export default PaymentSettings
